export const getAssignments = (state) => state.app.assignments;

export const getDirectory = (state) => state.app.members;

export const getMobileMenuVisible = (state) => state.app.mobileMenuVisible;

export const isLoggedIn = (state) => state.app.loggedIn;
